<template>
    <div class="msg-balloon msg-right">
    <figure>
        <v-avatar color="secondary" class="mr-2">
            伊
        </v-avatar>
    </figure>
    <div>
        <div class="msg-user">
            <p>
            伊藤誠一
            </p>
        </div><!-- .msg-text -->
        <div class="msg-text">
            <p>
            テキストテキストテキストテキストテキスト<br/>
            テキストテキストテキストテキストテキスト
            </p>
        </div><!-- .msg-text -->
    </div>
    </div><!-- .msg-balloon .msg-right -->

    <div class="msg-balloon msg-left">
    <figure>
        <v-avatar color="secondary" class="mr-2">
            田
        </v-avatar>
    </figure>
    <div>
        <div class="msg-user">
            <p>
            田中花子
            </p>
        </div><!-- .msg-text -->
        <div class="msg-text">
            <p>
            テキストテキストテキストテキストテキスト<br/>
            テキストテキストテキストテキストテキスト
            </p>
        </div><!-- .msg-text -->
    </div>
    </div><!-- .msg-balloon .msg-left -->

</template>

<style>
/* reset */
* {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
         -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
            box-sizing: border-box;
    -webkit-appearance: none;
            appearance: none;
}

/* 左右共通の記述 */
.msg-balloon {
    display: flex;
    align-items: flex-start;
    max-width: 90%;
    margin: 20px auto;
}
.msg-balloon figure {
    flex-shrink: 0;
    width: 48px;
}
.msg-balloon figure svg {
    min-width: 48px;
    min-height: 48px;
}
.msg-user {
    flex-grow: 1;
    padding: -10px;
    font-size: 0.675rem;
    line-height: 1.375rem;
    border-radius: 4px;
}
.msg-text {
    flex-grow: 1;
    padding: 15px 30px;
    color: #454545;
    font-size: 0.875rem;
    line-height: 1.375rem;
    border-radius: 4px;
    position: relative;
}
.msg-text::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-top: solid 6px transparent;
    border-bottom: solid 6px transparent;
    position: absolute;
    top: 7px;
}

/* アイコン右 */
.msg-right {
    margin-top: 20px;
    flex-direction: row-reverse;
}
.msg-right figure {
    margin-left: 20px;
}
.msg-right .msg-text {
    background: #f5f5f5;
}
.msg-right .msg-text::after {
    border-left: solid 12px #f5f5f5;
    right: -12px;
}
.msg-right .msg-user {
    text-align: right;
}

/* アイコン左 */
.msg-left figure {
    margin-right: 20px;
}
.msg-left .msg-text {
    background: #ece9e3;
}
.msg-left .msg-text::after {
    border-right: solid 12px #ece9e3;
    left: -12px;
}
.msg-left .msg-user {
    text-align: left;
}

</style>